import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AiChatWindowService, AuthenticationService } from 'app/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'app';

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    public aiChatWindowService: AiChatWindowService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        (<any>window).gtag('set', 'page', event.urlAfterRedirects);
        (<any>window).gtag('send', 'pageview');
      }
    });
  }

  isAdmin() {
    return this.authenticationService.isAdminUser();
  }

  isDev() {
    return this.authenticationService.isDevUser();
  }
}
